import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import 'video.js/dist/video-js.css';
import videojs from 'video.js';
export const videoOptions = {
    responsive: true,
    fluid: true,
    preload: 'auto',
    html5: {
        hls: {
            enableLowInitialPlaylist: true,
            smoothQualityChange: true,
            overrideNative: true,
        },
    },
};
export const VideoPlayer = ({ src, controls = true, autoplay = false, videoRef: propRef, onReady, style, ...rest }) => {
    const videoRef = useRef(null);
    const [player, setPlayer] = useState(null);
    useEffect(() => {
        const vjsPlayer = videojs(videoRef.current, {
            ...videoOptions,
            controls,
            autoplay,
            sources: [{ src }],
            ...rest,
        }, () => {
            if (onReady) {
                onReady();
            }
        });
        if (propRef) {
            propRef.current = vjsPlayer;
        }
        setPlayer(vjsPlayer);
    }, [autoplay, controls, onReady, propRef, rest, src]);
    useEffect(() => {
        return () => {
            if (player) {
                player.dispose();
                videoRef.current = null;
            }
        };
    }, [player]);
    useEffect(() => {
        if (player !== null) {
            player.src({ src });
        }
    }, [player, src]);
    return (_jsx("div", { "data-vjs-player": true, style: style, children: _jsx("video", { ref: videoRef, className: "video-js vjs-big-play-centered" }) }));
};
